var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Button, Dialog, Icon, Table } from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import { WebSocketMessage } from "../../serverConnection";
var Enterprises = /** @class */ (function (_super) {
    __extends(Enterprises, _super);
    function Enterprises() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: -1 };
        _this.onDelete = function (id) {
            _this.setState({ open: -1 });
            _this.props.send(WebSocketMessage("enterprises", "delete", { id: id }));
        };
        return _this;
    }
    Enterprises.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentUser = _a.currentUser, enterprises = _a.enterprises, history = _a.history;
        var isAllowed = ["su", "admin", "agent"].includes(currentUser.role);
        var isSu = currentUser.role === "su";
        if (!isAllowed) {
            history.push("/users");
        }
        var ents = enterprises
            .filter(function (e) { return isSu || currentUser.enterprises.includes(e.id); })
            .map(function (e, i) { return (React.createElement("tr", { key: e.id },
            React.createElement("td", null, e.name),
            React.createElement("td", null, e.countries.join(", ")),
            React.createElement("td", null,
                React.createElement(Link, { to: "/newenterprise/" + e.id },
                    React.createElement(Icon, null, "edit"))),
            React.createElement("td", null,
                React.createElement(Button, { onClick: function () { return _this.setState({ open: i }); } },
                    React.createElement(Icon, null, "clear")),
                React.createElement(Dialog, { open: _this.state.open === i, onClose: function () { return _this.setState({ open: -1 }); } },
                    React.createElement("div", { style: { margin: 8 } },
                        React.createElement("p", null,
                            "Are you sure you want to delete ",
                            e.name,
                            "?"),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Button, { onClick: function () { return _this.onDelete(e.id); } },
                            React.createElement(Icon, null, "delete"),
                            " Delete"),
                        "\u00A0",
                        React.createElement(Button, { onClick: function () { return _this.setState({ open: -1 }); } }, "Close")))))); });
        return (React.createElement("div", { className: "container content" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col s12 m12 l12" },
                    React.createElement("h5", { className: "" }, "Enterprises"),
                    React.createElement("br", null),
                    React.createElement("div", { className: "card-panel" },
                        React.createElement(Table, null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Name"),
                                    React.createElement("th", null, "Countries"),
                                    React.createElement("th", null),
                                    React.createElement("th", null))),
                            React.createElement("tbody", null, ents)))))));
    };
    return Enterprises;
}(Component));
export default withRouter(Enterprises);



//////////////////
// WEBPACK FOOTER
// ./src/components/enterprises/Enterprises.tsx
// module id = 1304
// module chunks = 0